"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  ProtectedStore: () => ProtectedStore
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneProtectedStore");
  return hybrid;
}
function createItem(key, value, policy) {
  return native().createItem(key, value, policy).catch(import_nativeError.rethrowNativeError);
}
function getItem(key, reason, policy) {
  return native().getItem(key, reason, policy).then(function(value) {
    return value !== null && value !== void 0 ? value : null;
  }, import_nativeError.rethrowNativeError);
}
function updateItem(key, value, reason, policy) {
  return native().updateItem(key, value, reason, policy).catch(import_nativeError.rethrowNativeError);
}
function deleteItem(key, reason, policy) {
  return native().deleteItem(key, reason, policy).catch(import_nativeError.rethrowNativeError);
}
var ProtectedStore = Object.freeze({
  createItem,
  getItem,
  updateItem,
  deleteItem
});
//# sourceMappingURL=index.native.js.map
